<template>
	<div class="relative z-10">
		<ProductRibbonHelp
			v-if="ribbon.type === Ribbon.vHelp && vHelpPrice"
			class="max-sm:max-w-[4.1875rem]"
			:price="vHelpPrice"
		/>

		<div
			v-else-if="ribbon.type === Ribbon.COUPON"
			class="flex items-center max-xs:flex-col justify-center z-10 relative bg-brand-mujglobus-green rounded-lg px-[.375rem] py-[.3125rem] sm:p-1 xs:gap-1.5"
		>
			<NuxtIcon name="custom/discount-lite" class="text-[1.375rem] text-brand-globus-green-dark size-[1.5rem] flex items-center justify-center" filled />
			<span v-if="ribbon.label" class="text-brand-globus-green-dark font-secondary text-xs max-xs:leading-4 sm:mr-[.375rem]">
				{{ ribbon.label }}
			</span>
		</div>

		<template v-else-if="imageAltText">
			<NuxtImg
				v-if="isProductDetail"
				:src="`/images/ribbons/${ribbon.type}.png`"
				width="90"
				height="70"
				class="max-md:w-[4.5rem]"
				:alt="imageAltText"
			/>
			<NuxtImg
				v-else
				:src="`/images/ribbons/${ribbon.type}-sm.png`"
				width="48"
				height="38"
				:alt="imageAltText"
			/>
		</template>
	</div>
</template>

<script setup lang="ts">
	import {Ribbon, type RibbonData} from '@/types/product';

	type Props = {
		ribbon: RibbonData;
		isProductDetail?: boolean;
		vHelpPrice?: number;
	};

	const props = defineProps<Props>();

	const altMap: Record<string, string> = {
		[Ribbon.vVVGButchery]: 'Řeznictví',
		[Ribbon.vVVGBakery]: 'Pekárna',
		[Ribbon.vVVGRestaurant]: 'Restaurace',
	};

	const imageAltText = computed(() => altMap[props.ribbon.type] || null);
</script>
